import { getallDishesByCompanyId } from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { SelectWithAdd } from "./SelectWithAdd";

interface DishSelectionProps {
  companyId?: string;
  onAddNew: () => void;
  onChange: React.ChangeEventHandler<HTMLSelectElement> | undefined;
  defaultValue?: string;
}

export function DishSelection({
  companyId,
  onAddNew,
  onChange,
  defaultValue,
}: DishSelectionProps) {
  const { data: dishes, isPending } = useQuery({
    queryKey: ["dishesByCompany", companyId],
    queryFn: () => getallDishesByCompanyId(companyId ?? ""),
    enabled: !!companyId,
  });
  const { t } = useTranslation();
  return (
    <SelectWithAdd
      options={dishes?.map((dish) => ({
        label: dish.name || "",
        value: dish.name || "",
      }))}
      placeholder={t("food.Select a Product")}
      onAddNew={onAddNew}
      disabled={isPending}
      onChange={onChange}
      defaultValue={defaultValue}
    />
  );
}
